import { ChangeEvent, FC } from 'react';
import { useDebounceCallback } from 'shared/lib/debounce';
import { PaginationHook, usePaginationFilter } from 'shared/lib/pagination';
import { InputSearch } from 'shared/ui/inputSearch';

interface SearchProps {
	hide?: boolean;
}

export const Search: FC<SearchProps> = ({ hide = false }) => {
	const paginationFilter = usePaginationFilter() as PaginationHook;
	const debounceSearch = useDebounceCallback(search => {
		if (paginationFilter) {
			const { fetchDataWithDispatch, filters } = paginationFilter;
			const paramsObj = { ...filters, search, page: 1 };
			fetchDataWithDispatch(paramsObj);
		}
	}, 300);

	const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		debounceSearch(value);
	};

	return (
		<>
			<InputSearch onChange={handleSearch} hide={hide} />
		</>
	);
};
